import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { DualAuthService } from '../../services/DualAuthService';

@Component({
  selector: 'app-pending-activation',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  template: `
    <div class="pending">
      <mat-icon class="icon">hourglass_empty</mat-icon>
      <h2>Your account is pending activation</h2>
      <p>An administrator must activate your account before you can proceed.</p>
      <div class="actions">
        <button mat-flat-button color="primary" (click)="refresh()">Check again</button>
        <button mat-stroked-button color="warn" (click)="logout()">Logout</button>
      </div>
    </div>
  `,
  styles: [
    `.pending{display:flex;flex-direction:column;align-items:center;gap:12px;padding:48px 16px;text-align:center}`,
    `.icon{font-size:40px;color:#ff9800}`,
    `.actions{display:flex;gap:12px;margin-top:8px}`,
  ]
})
export class PendingActivationComponent {
  constructor(private router: Router, private auth: DualAuthService) {}
  refresh(): void { this.router.navigate(['customer/welcome']); }
  logout(): void { this.auth.logout(); }
}
